import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

import AuthCallbackController from "./AuthCallbackController";
import AuthCallbackConfiguration from "./AuthCallbackConfiguration";

export default angular
    .module("trackerbase-app.views.auth-callback", DependencyListBuilder([
        AuthCallbackController.dependencies,
        AuthCallbackConfiguration.dependencies
    ]))
    .config(AuthCallbackConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/auth-callback/AuthCallback.js
// module id = zwMH
// module chunks = 1